<div [hidden]="consulta" class="evaluacion">
        <div class="row" style="position: sticky; top: 0; z-index: 1;">
            <div class="col-lg-12" style="padding: 0px">
                <section class="widget ">

                    <header>
                        <h3> {{titulo}} </h3>
                        <div class="separador"></div>
                        <div class="divisor8"></div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" *ngIf="visualizacion.tipovisualizacionrespuestaid == 1">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <inputCustom [titulo]="'Alumno que evalúa'"
                                        [(ngModel)]="entidad.apellidopaterno+' '+ entidad.apellidomaterno+' '+ entidad.primernombre"
                                        [disabled]="true"></inputCustom>
                                    </div>
                                    <div class="col-lg-6">
                                        <div *ngIf="entidad.foto">
                                            <div class="imagenalumno">
                                                <imagenVisualizador [imagen]="entidad.foto"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit"></imagenVisualizador>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" *ngIf="visualizacion.tipovisualizacionrespuestaid == 1">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div *ngIf="listapreguntas.evaluacionpendienterelacionid == 1">
                                    <inputCustom [titulo]="'Persona a evaluar'"
                                        [(ngModel)]="listapreguntas.personaaevaluar"
                                        [disabled]="true"></inputCustom>
                                    <inputCustom [titulo]="'Materia'"
                                        [(ngModel)]="listapreguntas.asignacion"
                                        [disabled]="true"></inputCustom>
                                </div>
                                <div *ngIf="listapreguntas.evaluacionpendienterelacionid == 2">
                                    <inputCustom [titulo]="'Persona a evaluar'"
                                        [(ngModel)]="listapreguntas.personaaevaluar"
                                        [disabled]="true"></inputCustom>
                                    <inputCustom [titulo]="'Puesto'"
                                        [(ngModel)]="listapreguntas.asignacion"
                                        [disabled]="true"></inputCustom>
                                    <inputCustom [titulo]="'Departamento'"
                                        [(ngModel)]="listapreguntas.departamento"
                                        [disabled]="true"></inputCustom>
                                </div>
                                </div>
                                <div class="col-lg-6">
                                    <div *ngIf="listapreguntas.urlfotografia">
                                        <div class="imagenalumno">
                                            <imagenVisualizador [imagen]="listapreguntas.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit"></imagenVisualizador>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12" *ngIf="visualizacion.tipovisualizacionrespuestaid == 2">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div *ngIf="entidad.evaluacionpendienterelacionid == 1">
                                        <inputCustom [titulo]="'Persona a evaluar'"
                                            [(ngModel)]="entidad.persona"
                                            [disabled]="true"></inputCustom>
                                        <inputCustom [titulo]="'Materia'"
                                            [(ngModel)]="entidad.materia"
                                            [disabled]="true"></inputCustom>
                                    </div>
                                    <div *ngIf="entidad.evaluacionpendienterelacionid == 2">
                                        <inputCustom [titulo]="'Persona a evaluar'"
                                            [(ngModel)]="entidad.persona"
                                            [disabled]="true"></inputCustom>
                                        <inputCustom [titulo]="'Puesto'"
                                            [(ngModel)]="entidad.puesto"
                                            [disabled]="true"></inputCustom>
                                        <inputCustom [titulo]="'Departamento'"
                                            [(ngModel)]="entidad.departamento"
                                            [disabled]="true"></inputCustom>
                                    </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6" >
                                        <div class="row margen h-100" *ngIf="entidad.urlfotografia">
                                            <div class="imagenalumno col-auto">
                                                <imagenVisualizador [imagen]="entidad.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit"></imagenVisualizador>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </section>
            </div>
        </div>

        <div class="divisor8"></div>
        <evaluacion #datosDesdeElPadre *ngIf="listapreguntas.length > 0 || listapreguntas.cicloid"
        [listapreguntas]="listapreguntas"
        [objobservacion]="objobservacion"
        [tipovisualizacioncompetenciacriterio]="visualizacion.tipovisualizacioncompetenciacriterioid"
        [tipovisualizacionpregunta]="visualizacion.tipovisualizacionpreguntaid"
        [tipovisualizacionrespuesta]="visualizacion.tipovisualizacionrespuestaid"
        (sinterminar)="sinterminar()"
        (terminado)="terminado()"
        (comentario)="guardarcomentario($event)"
        (salir)="salir()"
        (cambiarevaluacion)="empezarencuesta()"
        (guardarrespuesta)="guardarrespuesta($event)"
        ></evaluacion>
</div>